// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-news-js": () => import("/srv/maya/src/templates/news.js" /* webpackChunkName: "component---src-templates-news-js" */),
  "component---src-pages-404-js": () => import("/srv/maya/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("/srv/maya/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-devices-js": () => import("/srv/maya/src/pages/devices.js" /* webpackChunkName: "component---src-pages-devices-js" */),
  "component---src-pages-index-js": () => import("/srv/maya/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-products-js": () => import("/srv/maya/src/pages/products.js" /* webpackChunkName: "component---src-pages-products-js" */),
  "component---src-pages-references-js": () => import("/srv/maya/src/pages/references.js" /* webpackChunkName: "component---src-pages-references-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/srv/maya/.cache/data.json")

